/**
 * Client typé pour les routes `/expenses` — Phase 4, incrément 4.10.3,
 * étendu **offline-first** en Phase 3.3.3.
 *
 * Troisième sub-entité coparenting. Pattern symétrique à journal
 * (3 méthodes, pas d'update). Particularité : `amount` est un
 * `number` côté JSON (le serveur parse depuis `numeric` SQL).
 * Mutations passent par `sendOrQueueMutation` (cf. 3.3.2).
 */
import { apiRequest } from './client.js';
import { sendOrQueueMutation, type SendResult } from './mutationsReplay.js';

export interface ApiExpense {
  id: string;
  homeId: string;
  description: string;
  amount: number;
  category: string;
  paidBy: 'A' | 'B';
  /** `YYYY-MM-DD`. */
  date: string;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateExpenseInput {
  description: string;
  amount: number;
  category: string;
  paidBy: 'A' | 'B';
  /** `YYYY-MM-DD`. Si absent, le serveur applique aujourd'hui. */
  date?: string;
}

export async function listExpenses(homeId: string): Promise<ApiExpense[]> {
  const data = await apiRequest<{ expenses: ApiExpense[] }>(`/homes/${homeId}/expenses`);
  return data.expenses;
}

export async function createExpense(
  homeId: string,
  input: CreateExpenseInput,
  localId?: string,
): Promise<SendResult<{ expense: ApiExpense }>> {
  return sendOrQueueMutation<{ expense: ApiExpense }>({
    method: 'POST',
    path: `/homes/${homeId}/expenses`,
    body: input,
    ...(localId ? { localId } : {}),
  });
}

export async function deleteExpense(id: string): Promise<SendResult<void>> {
  return sendOrQueueMutation<void>({
    method: 'DELETE',
    path: `/expenses/${id}`,
  });
}
